import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { authenticationGuard } from "./routeGuard";
import {
  HOME,
  LOGIN,
  ExportTemplatePdf,
  ExportTemplateExcelCsv,
  OperationsDaily,
  OperationsHourly,
  Accounting,
  OperationsExpired,
  AzureCost,
  KioskGlobal,
  KioskGlobalUpdated,
  KioskCompare,
  Games,
  GamesSimple,
  GamesCompare,
  Snacking,
  Merchandising,
  Staff,
  StaffHistory,
  Cards,
  ExportMail,
  ExportMailMaintenance,
  SmartTouchMaintenance,
  BusinessOmniplayEventsPresta,
  BusinessOmniplayEventsOrder,
  Cake,
  GamesCode,
  OmniplayReport,
  OperationsPeriodical,
  OperationsCompare,
  BusinessOmniplayEventsPrestaSimple,
  BusinessOmniplayEventsOrderSimple,
  ConsumptionReport
} from "./routeNames";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: HOME,
    component: Home,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },

  {
    path: "/login",
    name: LOGIN,
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
  },
  {
    path: "/export_template/pdf",
    name: ExportTemplatePdf,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/export/ExportTemplatePdf.vue"
      ),
  },
  {
    path: "/export_template/:expFormat?",
    name: ExportTemplateExcelCsv,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/export/ExportTemplateExcelCsv.vue"),
  },
  {
    path: "/export_mail",
    name: ExportMail,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/export/ExportMail.vue"),
  },
  {
    path: "/export_mail_maintenance",
    name: ExportMailMaintenance,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/export/ExportMailMaintenance.vue"
      ),
  },
  {
    path: "/operations_periodical",
    name: OperationsPeriodical,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/OperationsPeriodical.vue"
      ),
  },
  {
    path: "/operations_daily",
    name: OperationsDaily,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/OperationsDaily.vue"
      ),
  },
  {
    path: "/operations_hourly",
    name: OperationsHourly,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/OperationsHourly.vue"
      ),
  },
  {
    path: "/operations_compare",
    name: OperationsCompare,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/OperationsCompare.vue"
      ),
  },
  {
    path: "/accounting",
    name: Accounting,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/Accounting.vue"
      ),
  },
  {
    path: "/operations_expired",
    name: OperationsExpired,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/operations/OperationsExpired.vue"
      ),
  },
  {
    path: "/azure_cost",
    name: AzureCost,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/statistics/AzureCost.vue"
      ),
  },
  {
    path: "/kiosk_global",
    name: KioskGlobal,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/kiosk/KioskGlobal.vue"),
  },
  {
    path: "/kiosk_global_Updated",
    name: KioskGlobalUpdated,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/kiosk/KioskGlobalUpdated.vue"
      ),
  },
  {
    path: "/kiosk_compare",
    name: KioskCompare,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/kiosk/KioskCompare.vue"),
  },
  {
    path: "/games",
    name: Games,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/categories/Games.vue"),
  },
  {
    path: "/games_code",
    name: GamesCode,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/categories/GamesCode.vue"
      ),
  },
  {
    path: "/games_simple",
    name: GamesSimple,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/categories/GamesSimple.vue"
      ),
  },
  {
    path: "/games_compare",
    name: GamesCompare,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/categories/GamesCompare.vue"
      ),
  },
  {
    path: "/snacking",
    name: Snacking,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/categories/Snacking.vue"
      ),
  },
  {
    path: "/merchandising",
    name: Merchandising,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/categories/Merchandising.vue"
      ),
  },
  {
    path: "/staff",
    name: Staff,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/staff/Staff.vue"),
  },
  {
    path: "/staff_history",
    name: StaffHistory,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/staff/StaffHistory.vue"),
  },
  {
    path: "/cards",
    name: Cards,
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/statistics/Cards.vue"),
  },
  {
    path: "/onmniplay_report",
    name: OmniplayReport,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/statistics/OmniplayReport.vue"
      ),
  },
  {
    path: "/consumption_report",
    name: ConsumptionReport,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/statistics/ConsumptionReport.vue"
      ),
  },
  {
    path: "/subscriptions",
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/MailSubscriptions.vue"),
  },
  {
    path: "/smart_touch_maintenance",
    name: SmartTouchMaintenance,
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/SmartTouchMaintenance.vue"
      ),
  },
  {
    path: "/events_accounting",
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/events/OmniplayEventsAccounting.vue"
      ),
  },
  {
    name: BusinessOmniplayEventsPresta,
    path: "/business_events_presta",
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/events/BusinessOmniplayEventsPresta.vue"
      ),
  },
  {
    name: BusinessOmniplayEventsOrder,
    path: "/business_events_order",
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/events/BusinessOmniplayEventsOrder.vue"
      ),
  },
  {
    name: BusinessOmniplayEventsPrestaSimple,
    path: "/business_events_presta_simple",
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/events/BusinessOmniplayEventsPrestaSimple.vue"
      ),
  },
  {
    name: BusinessOmniplayEventsOrderSimple,
    path: "/business_events_order_simple",
    component: () =>
      import(
        /* webpackChunkName: "export" */ "@/views/events/BusinessOmniplayEventsOrderSimple.vue"
      ),
  },
  {
    name: Cake,
    path: "/cake",
    component: () =>
      import(/* webpackChunkName: "export" */ "@/views/events/Cake.vue"),
  },

  // when a wrong route is used redirect to /
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// before enter in each route
router.beforeEach(authenticationGuard(router));

export default router;
